export const useNumericArrows = ({ value, onIncrement, onDecrement, onValueChange }) => {
    const handleIncrement = () => {
        const newValue = onIncrement(value);
        onValueChange(newValue);
    };
    const handleDecrement = () => {
        const newValue = onDecrement(value);
        onValueChange(newValue);
    };
    return {
        handleIncrement,
        handleDecrement
    };
};
